module.exports = __webpack_public_path__ + "img/shareMini.ac1a8e3e.jpg";